import axios from 'axios';

export function getProjectRatingSync(giverProjectUserId) {
  return axios.get(`/project/${giverProjectUserId}/rating`).then(
      resp => resp.data);
}

export async function getProjectRating(giverProjectUserId) {
  let response = await axios.get(`/project/${giverProjectUserId}/rating`);
  return response.data;
}

export function rate(payload) {
  return axios.post('/project/rating/rate', payload);
}